import { render } from "./AgoraMeeting.vue?vue&type=template&id=35d1bcd3&scoped=true"
import script from "./AgoraMeeting.vue?vue&type=script&lang=js"
export * from "./AgoraMeeting.vue?vue&type=script&lang=js"

import "./AgoraMeeting.vue?vue&type=style&index=0&id=35d1bcd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d1bcd3"],['__file',"src/components/AgoraMeeting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35d1bcd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35d1bcd3', __exports__)) {
    api.reload('35d1bcd3', __exports__)
  }
  
  module.hot.accept("./AgoraMeeting.vue?vue&type=template&id=35d1bcd3&scoped=true", () => {
    api.rerender('35d1bcd3', render)
  })

}


export default __exports__